'use strict';

angular.module('app.dashboard')
	.controller('dashboardCtrl', function($scope, $translate, $state, $http, $experiments,
		dashboardService, focus, navigationService, dashboardCreationService, leanFilterService, userConfigUtilsService, URLS) {
		if (globalConfig.user.role === 'Supplier') {
			navigationService.goToDefaultSupplierReport('supply-chain');
		} else {
			$scope.dashboard = { title: '', startwith: '' };
			navigationService.setFirstView({
				viewType: 'dashboards',
				baseReportName: 'new-dashboard'
			});
			$http.get(String.format(URLS.dashboards, globalConfig.customer.id)).then(
				function (response) {
					$scope.dashboards = dashboardService.moveEmptyToEndOfList(response.data);
					var isCtbSingleLevelEnabled = userConfigUtilsService.getClearToBuildSingleLevelEnabledForUser();
					var isCtbMultiLevelEnabled = userConfigUtilsService.getClearToBuildMultiLevelEnabledForUser();
					var plannerPerformanceSingleLevelIdx = -1;
					var plannerPerformanceMultiLevelIdx = -1;
					for(var i=0; i < $scope.dashboards.length; i++){
						if($scope.dashboards[i].name === 'Planner Performance (Single Level)'){
							plannerPerformanceSingleLevelIdx = i;
						}
						if($scope.dashboards[i].name === 'Planner Performance (Multi Level)'){
							plannerPerformanceMultiLevelIdx = i;
						}
					}
					if(!isCtbSingleLevelEnabled){
						$scope.dashboards.splice(plannerPerformanceSingleLevelIdx, 1);
					}
					if(!isCtbMultiLevelEnabled){
						$scope.dashboards.splice(plannerPerformanceMultiLevelIdx, 1);
					}
					focus('startWith');
				},
				function (error) { }
			);
		}
		
		
		$scope.updateDashboardName = function() {
			var dd = $scope.dashboard;
			var startwith = dd.startwith;
			if (startwith) {
				startwith = JSON.parse(startwith);
				dd.title = $translate.instant(startwith.name);
			} else {
				dd.title = '';
			}
		};
		
		$scope.addDashboard = function() {
			var dd = $scope.dashboard;
			var startwith = dd.startwith;
			if (startwith) {
				startwith = JSON.parse(startwith);
			}

			var isXMatrix = startwith && startwith.config.includes('"type":"xMatrix"');
			var defaultFactoryFilter = !isXMatrix ? leanFilterService.leanDnaAllSelected : globalConfig.factory.id;
			var filters =[{id: 'factory', values: [defaultFactoryFilter]}];
			if(startwith.name === 'Planner Performance (Single Level)' || startwith.name === 'Planner Performance (Multi Level)'){
				filters.push(
					{
						id: 'ctbTimePeriod',
						values: ['ctbWindow'],
						comparator: leanFilterService.comparatorsMap.ctbWindow
					}
				);
			}


			var newDashboard = {
				reportName: dd.title,
				baseReportName: startwith ? startwith.name: '',
				filters: filters,
				columns: [],
				recordsPerPage: 0,
				viewType: 'dashboards',
				type: 'customer',
				userModified: true,
				search: '',
				config: startwith  ? JSON.parse(startwith.config) : {}
			};

			dashboardCreationService.createDashboard(newDashboard, createDashboardCallback);
		};

		$scope.onSave = function() {
			if ($scope.dashboard.title.trim() != '' && $scope.dashboard.startwith != '') {
				return true;
			}
		};

		function createDashboardCallback(response, newDashboard) {
			pendo.track('addDashboard', {
				name: newDashboard.reportName,
				parentName: newDashboard.baseReportName,
				structure: newDashboard.config.layout
			});
			var state = navigationService.getStateForDashboard({id: response.data.ndx, baseReportName: newDashboard.baseReportName});
			$state.go(state.sref, state.params);
		}
	});
